export default __webpack_public_path__ + "static/Nail1-b83f8a56e922b41ebfc7c0096ea04281.png";